import BaseForgeCustomizer from '../base-forge';
import athenaConfig from '../../config';

const { classic } = athenaConfig;

export default class EnrollQuestionClassic extends BaseForgeCustomizer {
  headerText = 'Set up security question';
  async shouldCustomize() {
    return classic && [ 'enroll-question' ].includes(this.context?.controller);
  }
}
